<template>
    <st-filters-pagination
        stateModule="decisionTarget/list"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :header="$t('DECISION_TARGET.LIST.TITLE')"
        :moreFilters="false"
        :showErase="false"
    >
        <template #filters-toolbar>
            <slot name="toolbar"></slot>
        </template>
        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { DecisionTargetModel } from '@/modules/decision-target/decision-target-model';

    const { fields } = DecisionTargetModel;

    const filterSchema = new FilterSchema([
        fields.name,
    ]);

    export default {
        name: 'DecisionTargetListFilter',
        data() {
            return {
                filters: filterSchema.fields,
                currentPage: 1,
            };
        },
        computed: {
            ...mapGetters({
               total: 'decisionTarget/list/total',
            }),
        },
        methods: {
            ...mapActions({
                doFetch: 'decisionTarget/list/doFetch',
            }),
            refresh() {
                this.doFilter(this.params);
            },
            async doFilter(params) {
                this.params = params;
                this.doFetch(params);
            },
        },

    };
</script>

<style scoped>

</style>
